module.exports = __webpack_public_path__ + "static/media/poa.a7edf9be.svg";